import { useMemo } from 'react';

import { AdditionalEntitlement } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { ValidationRules } from '@dreryk/react-common';

import {
   mapPrescriptionReimbursementToReimbursement,
   MedicinePrescriptionReimbursement,
} from '~libs.shared.prescription';

import { draftPrescriptionsTranslationKeys } from '../../../../../translations';
import { ReimbursementSelector } from '../../../reimbursement/ReimbursementSelector';
import { ReimbursementSelectorValue } from '../../../reimbursement/ReimbursementSelector.types';
import { DraftPrescriptionsFormBean, DraftPrescriptionsFormController } from '../DraftPrescriptionsForm.types';
import { DraftStandardPrescriptionFieldName } from '../standardPrescription/DraftStandardPrescriptionField.types';
import { DraftMagistralDrugPrescriptionFieldName } from '../magistralDrugPrescription/DraftMagistralDrugPrescriptionField.types';

const REIMBURSEMENT_VALIDATION_RULES: ValidationRules<DraftPrescriptionsFormBean> = {
   required: {
      value: true,
      message: draftPrescriptionsTranslationKeys.chooseReimbursement,
   },
};

type DraftReimbursementSelectorProps = Pick<DraftPrescriptionsFormController, 'register'> & {
   readonly name: DraftStandardPrescriptionFieldName | DraftMagistralDrugPrescriptionFieldName;
   readonly defaultValue: ReimbursementSelectorValue;
   readonly reimbursements: MedicinePrescriptionReimbursement[];
   readonly visitDiagnoses: VisitDiagnosis[];
   readonly selectedEntitlements: AdditionalEntitlement[];
};

export const DraftReimbursementSelector = (props: DraftReimbursementSelectorProps): JSX.Element => {
   const reimbursements = useMemo(() => props.reimbursements.map(mapPrescriptionReimbursementToReimbursement), [
      props.reimbursements,
   ]);

   return (
      <ReimbursementSelector
         controller={props.register(props.name, REIMBURSEMENT_VALIDATION_RULES)}
         defaultValue={props.defaultValue}
         visitDiagnoses={props.visitDiagnoses}
         reimbursements={reimbursements}
         testId={'reimbursements'}
         selectedEntitlements={props.selectedEntitlements}
      />
   );
};
